import { Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DeviceparamModel} from '../../../../api/src/deviceparam/deviceparam.model';
import {CalcparamModel} from '../../../../api/src/calcparam/calcparam.model';
import {ExpressionFormMetaInfo} from '../standard-form-builder/standard-form-meta-info.model';
import { ParamlistModel } from '../../../../api/src/paramlist/paramlist.model';
import { HttpClient } from '@angular/common/http';
import _ from 'lodash';
import {InsparkMessageService} from '@inspark/inspark-components';
import {ContrdeviceparamModel} from '../../../../api/src/contr-device-param/contrdeviceparam.model';
import {UnitModel} from '../../../../api/src/unit/unit.model';


@Component({
    selector: 'in-expression-builder',
    templateUrl: './expression-builder.component.html',
    styleUrls: ['./expression-builder.component.scss'],
    standalone: false
})
export class ExpressionBuilderComponent implements OnInit {
  @Input() expression = '';
  @Input() showParsedExpression = false;
  @Output() expressionChange = new EventEmitter<string>();
  @Output() change = new EventEmitter();
  @Output() filterParams = new EventEmitter();
  @Output() resolveParamNames = new EventEmitter<string[]>();
  @Output() loadParams = new EventEmitter<void>();
  @Input() meta: ExpressionFormMetaInfo;
  @Input() item: any = {};
  @Input() itemOptions: {
    deviceparams: DeviceparamModel[];
    calcparams: CalcparamModel[];
    semuxParams: any[];
    contrdeviceparams: ContrdeviceparamModel[];
    paramsLabels: any[];
    units:  UnitModel[];} = {deviceparams: [], calcparams: [], semuxParams: [], contrdeviceparams: [], units: [], paramsLabels: []};
  @Input() showResolveButton = false;
  @Input() showParamsSearchButton = false;

  readonly DEFAULT_MAX_LENGTH = 65535;
  readonly SERVER_LOCATION_ID = 1;
  isOpen = false;
  operators = ['(', '+', '-', '/', '*', ')'];
  validators = [/^([-+/*]\d+(\.\d+)?)*/];
  storage: any = {};

  //selectedDeviceparam: DeviceparamModel;
  selectDeviceparamDisabled = true;
  inputTextDsp = '';

  //selectedCalcparam: CalcparamModel;
  selectCalcparamDisabled = true;
  inputTextCcp = '';
  selectedParam: {label: string; value: ParamlistModel};

  enterPress = false;


  filteredCalcparamsSingle: any[];
  selectedCalcparam: any = null;
  filteredSelCalcparams: any[] = [];
  checkDdlFlag2 = false;

  filteredDeviceparamsSingle: any[];
  selectedDeviceparam: any = null;
  filteredSelDeviceparams: any[] = [];
  checkDdlFlag = false;

  filteredContrdeviceparamsSingle: any[];
  selectedContrdeviceparam: any = {label: null, value: null};
  filteredSelContrdeviceparams: any[] = [];
  checkDdlFlag3 = false;

  filteredUnitsSingle: any[];
  selectedUnit: any = {label: null, value: null};
  filteredSelUnits: any[] = [];
  checkDdlFlag4 = false;


  typicalconfigId = '';
  isFastCdpProcession = true;
  isFastCcpProcession = true;
  isFastUnitProcession = true;

  constructor(private http: HttpClient, private messageService: InsparkMessageService) {
  }

  ngOnInit() {
    this.operators = this.meta.operators || [];
    //
    if (this.itemOptions?.deviceparams && this.itemOptions.deviceparams.length < 500) {
      this.isFastCdpProcession = true;
      this.filteredSelDeviceparams = this.itemOptions.deviceparams;
    } else {
      this.isFastCdpProcession = false;
    }
    if (this.itemOptions?.calcparams && this.itemOptions.calcparams.length < 500) {
      this.isFastCcpProcession = true;
      this.filteredSelCalcparams = this.itemOptions.calcparams;
    } else {
      this.isFastCcpProcession = false;
    }

    if (this.itemOptions?.contrdeviceparams && this.itemOptions.contrdeviceparams.length < 500) {
      this.isFastCdpProcession = true;
      this.filteredSelContrdeviceparams = this.itemOptions.contrdeviceparams;
    } else {
      this.isFastCdpProcession = false;
    }

    if (this.itemOptions?.units && this.itemOptions.units.length < 500) {
      this.isFastUnitProcession = true;
      this.filteredSelUnits = this.itemOptions.units;
    } else {
      this.isFastUnitProcession = false;
    }


    this.typicalconfigId = this.item.typicalconfig?.id;
  }

  addSign(inField, sign) {
    if (!this.meta.constraints || !(this.meta.constraints.maxLength && (this.expression && this.expression.length >= this.meta.constraints.maxLength))) {
      this.expression = this.expSplice(inField.value, sign);
    }
    this.expressionChange.emit(this.expression);
    this.change.emit(this.expression);
  }

  addField(inField, target: 'D' | 'C' | 'R' | 'U') {
    if (this.meta.constraints && this.meta.constraints.maxLength && (this.expression && this.expression.length >= this.meta.constraints.maxLength)) {
      this.expressionChange.emit(this.expression);
      this.change.emit(this.expression);
    } else {
      const targets = {C: 'selectedCalcparam', D: 'selectedDeviceparam'};
      const value = this[targets[target]];
      if (value) {
        const valueId = value.value?.id ? value.value.id : value.value;
        this.expression = this.expSplice(inField.value, target + valueId);
        this.expressionChange.emit(this.expression);
        this.change.emit(this.expression);
      }
    }
  }

  addFieldByParams(inField): void {
    if (this.meta.constraints && this.meta.constraints.maxLength && (this.expression && this.expression.length >= this.meta.constraints.maxLength)) {
      this.expressionChange.emit(this.expression);
      this.change.emit(this.expression);
    } else {
      const value = this.selectedParam.value;
      const prefix = value.calc ? 'L' : 'P';
      if (value) {
        this.expression = this.expSplice(inField.value, prefix + value.id);
        this.expressionChange.emit(this.expression);
        this.change.emit(this.expression);
        this.selectedParam = undefined;
      }
    }
  }

  updateExpression() {
    this.expressionChange.emit(this.expression);
    this.change.emit(this.expression);
  }


  storeSelectionFrames(event) {
    if (!this.storage) {
      this.storage = {};
    }
    this.storage.selectionStart = event.target.selectionStart;
    this.storage.selectionEnd = event.target.selectionEnd;
  }

  humanize(expression) {
    let expressionReplaced = expression;
    const replacer = (items) => (textID) => {

      const id = +textID.match(/\d+/);
      const replacedArg = items.find(_item => +_item.id === +id);
      return replacedArg ? `"${replacedArg.paramname}"` : textID;
    };
    const RE_DEVICEPARAM = new RegExp('D\\d+', 'g');
    const RE_CALCPARAM = new RegExp('C\\d+', 'g');
    if (expression) {
      expressionReplaced = expressionReplaced.replace(RE_DEVICEPARAM, replacer(this.itemOptions.deviceparams || []));
      if (this.itemOptions.calcparams && this.itemOptions.calcparams.length > 0) {
        expressionReplaced = expressionReplaced.replace(RE_CALCPARAM, replacer(this.itemOptions.calcparams || []));
      }
    }


    if (expressionReplaced) {
      return expressionReplaced.split('\'');
    } else {
      return '';
    }
  }

  resolveParams(list: string[]): void {
    this.resolveParamNames.next(list);
  }

/*  processClick(event) {
    console.log('------Process Click-------');
    document.getElementById('textInput').style.display = 'block';//this.value === 'other' ? 'block' : 'none';"
  }*/

  isDisabled() {
    return this.selectDeviceparamDisabled;
  }

  textInputDsp = _.debounce(() => {
    if (this.enterPress) {
      this.enterPress = false;
      return false;
    }
    this.changeDspFilter();
  }, 1000);

  textInputCcp = _.debounce(() => {
    if (this.enterPress) {
      this.enterPress = false;
      return false;
    }
    this.changeCcpFilter();
  }, 1000);

  changeDspFilter() {
    const id = this.item.typicalconfig.id;
    const name = '*' + encodeURIComponent(this.inputTextDsp) + '*';
    const host = `/db/deviceparam/shortest?configId=${id}&name=${name}`;
    this.http.get(host).subscribe(data => {
      this.itemOptions.deviceparams = (data as any[]);
    }, error => {
      if (error.error?.Message) {
        this.messageService.error(error.error.Message);
      } else {
        this.messageService.error('Ошибка при обращении к серверу');
      }
    });
  }

  changeCcpFilter() {
    const id = this.item.typicalconfig.id;
    const name = '*' + encodeURIComponent(this.inputTextCcp) + '*';
    const host = `/db/calcparam/shortest?configId=${id}&name=${name}`;
    this.http.get(host).subscribe(data => {
      this.itemOptions.calcparams = (data as any[]);
    }, error => {
      if (error.error?.Message) {
        this.messageService.error(error.error.Message);
      } else {
        this.messageService.error('Ошибка при обращении к серверу');
      }
    });
  }

  onChangeDsp($event) {
      if ((this.inputTextDsp && this.inputTextDsp.length >= 3) || !this.selectDeviceparamDisabled ) {
        this.selectDeviceparamDisabled = false;
        this.textInputDsp();
      }
  }

  onChangeCcp($event) {
    if ((this.inputTextCcp && this.inputTextCcp.length >= 3) || !this.selectCalcparamDisabled ) {
      this.selectCalcparamDisabled = false;
      this.textInputCcp();
    }
  }
  filterDeviceparams(deviceparams) {
    if (this.item && this.item.typicalconfig) {
      const filteredDeviceparams = deviceparams.filter(_deviceparam => +_deviceparam.deviceconnect.typicalconfig.id === +this.item.typicalconfig.id);
      const categories = {};
      filteredDeviceparams.forEach(_fcdeviceparam => {
        categories[_fcdeviceparam.channel.device.devicename] = categories[_fcdeviceparam.channel.device.devicename] || [];
        categories[_fcdeviceparam.channel.device.devicename].push({id: _fcdeviceparam.id, name: _fcdeviceparam.paramname});
      });
      return categories;
    }
    return {};
  }

  filterCalcparams(calcparams) {
    if (this.item && this.item.typicalconfig) {
      const filteredCalcparams = calcparams.filter(_calcparam => +_calcparam.typicalconfig.id === +this.item.typicalconfig.id);
      const categories = {};
      filteredCalcparams.forEach(_fcalcparam => {
        categories[_fcalcparam.paramcategory.categoryname] = categories[_fcalcparam.paramcategory.categoryname] || [];
        categories[_fcalcparam.paramcategory.categoryname].push({id: _fcalcparam.id, name: _fcalcparam.paramname});
      });
      return categories;
    }
    return {};
  }

  toggleOpen() {
    this.isOpen = !this.isOpen;
  }

  compareById(a, b) {
    return a && b && a === b;
  }

  private expSplice(source, newItem) {
    const storage = this.storage;
    if (storage && storage.selectionStart && storage.selectionEnd && source.length > 0) {
      const Start = storage.selectionStart;
      const End = storage.selectionEnd;
      storage.selectionStart = storage.selectionStart + newItem.length;
      storage.selectionEnd = storage.selectionStart;
      return source ? source.slice(0, Start) + newItem + source.slice(End) : newItem;
    } else {
      return source + newItem;
    }
  }

  getTitle(str) {
    if (str && str.length > 50) {return str;}
    return null;
  }

  checkDdl(event, flag) {
    if (!flag) {return;}
    // console.log('ddl originalEvent: ', event.originalEvent);
    // console.log('ddl option: ', event.query);
    if (!this.checkDdlFlag) {
      this.checkDdlFlag = true;
      const dsp = (this.selectedDeviceparam?.label || this.selectedDeviceparam?.label === null) ? this.selectedDeviceparam.label : this.selectedDeviceparam;
      if ((flag === 0 && (!dsp || dsp == ''))) {
        this.textInput(flag, false);
      } else  if ((flag === 0 && !(dsp && dsp.length > 2))) {
        this.textInput(flag, true);
      }
    }
  }

  checkDdl2(event, flag) {
    // console.log('ddl originalEvent: ', event.originalEvent);
    // console.log('ddl option: ', event.query);
    if (!this.checkDdlFlag2) {
      this.checkDdlFlag2 = true;
      const act = (this.selectedCalcparam?.label || this.selectedCalcparam?.label === null) ? this.selectedCalcparam.label : this.selectedCalcparam;
      if ((flag === 1 && (!act || act == ''))) {
        this.textInput(flag, false);
      } else  if ((flag === 1 && !(act && act.length > 2))) {
        this.textInput(flag, true);
      }
    }
  }



  textInput = _.debounce((flag, p) => {
    this.changeFilter(flag, p);
  }, 1000);

  changeFilter(flag, p) {
    if (flag === 0) {
      const dsp = this.selectedDeviceparam?.label ? this.selectedDeviceparam.label : this.selectedDeviceparam;
      const name = p ? '&name=*' + encodeURIComponent(dsp) + '*' : '';
      const host = `/db/deviceparam/shortest?configId=${this.typicalconfigId}${name}`;
      this.http.get(host).subscribe(data => {
        this.filteredSelDeviceparams = (data as any[]);
        this.filteredDeviceparamsSingle = this.filterParam(this.selectedDeviceparam, this.filteredSelDeviceparams);
        //this.selectedDeviceparam = this.filteredDeviceparamsSingle.length === 0 ? this.ruleaction?.deviceparam : this.filteredDeviceparamsSingle[0];
      }, error => {
        if (error.error?.Message) {
          this.messageService.error(error.error.Message);
        } else {
          this.messageService.error('Ошибка при обращении к серверу');
        }
      });
    } else if (flag === 1) {
      const ccp = this.selectedCalcparam?.label ? this.selectedCalcparam.label : this.selectedCalcparam;
      const name = p ? '&name=*' + encodeURIComponent(ccp) + '*' : '';
      const host = `/db/calcparam/shortest?configId=${this.typicalconfigId}${name}`;
      this.http.get(host).subscribe(data => {
        this.filteredSelCalcparams = (data as any[]);
        this.filteredCalcparamsSingle = this.filterParam(this.selectedCalcparam, this.filteredSelCalcparams);
        //this.selectedRuleAction = this.filteredRuleActionsSingle.length === 0 ? this.ruleaction?.action : this.filteredRuleActionsSingle[0];
      });
    }
  }

  onKeyUp(event, flag) {
    if (event.keyCode === 17) {
      return;
    }
    if (event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 39 || event.keyCode === 37) {
      return;
    }
    if (flag === 0) {
      this.checkDdlFlag = false;
    } else if (flag === 1) {
      this.checkDdlFlag2 = false;
    }

    const dsp = (this.selectedDeviceparam?.label || this.selectedDeviceparam?.label === null) ? this.selectedDeviceparam.label : this.selectedDeviceparam;
    const act = (this.selectedCalcparam?.label || this.selectedCalcparam?.label === null) ? this.selectedCalcparam.label : this.selectedCalcparam;
    if (event.keyCode === 13) {
      if ((flag === 0 && (!dsp || dsp == '')) || (flag === 1 && (!act || act == ''))) {
        this.textInput(flag, false);
      } else  if ((flag === 0 && !(dsp && dsp.length > 2)) || (flag === 1 && !(act && act.length > 2))) {
        this.textInput(flag, true);
      }

    } else if ((flag === 0 && dsp && dsp.length >= 3) ||  (flag === 1 && act && act.length >= 3)) {
      this.textInput(flag, true);
    }
  }
  filterDeviceparamSingle(event) {
    const query = event.query;
    this.filteredDeviceparamsSingle = this.filterParam(query, this.filteredSelDeviceparams);
    //this.selectedDeviceparam = this.filteredDeviceparamsSingle.length === 0 ? query : this.filteredDeviceparamsSingle[0];
  }

  filterCalcparamSingle(event) {
    const query = event.query;
    this.filteredCalcparamsSingle = this.filterParam(query, this.filteredSelCalcparams);
    //this.selectedDeviceparam = this.filteredDeviceparamsSingle.length === 0 ? query : this.filteredDeviceparamsSingle[0];
  }

  filterContrdeviceparamSingle(event) {
    const query = event.query;
    this.filteredContrdeviceparamsSingle = this.filterCDParam(query, this.filteredSelContrdeviceparams);
    //this.selectedDeviceparam = this.filteredDeviceparamsSingle.length === 0 ? query : this.filteredDeviceparamsSingle[0];
  }

  filterUnitSingle(event) {
    const query = event.query;
    this.filteredUnitsSingle = this.filterUnit(query, this.filteredSelUnits);
    //this.selectedDeviceparam = this.filteredDeviceparamsSingle.length === 0 ? query : this.filteredDeviceparamsSingle[0];
  }



  filterParam(query, params: any[]): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < params.length; i++) {
      const param = params[i];
      if (param && query && param.paramname && param.paramname.toLowerCase().indexOf((query + '').toLowerCase()) !== -1) {
        filtered.push({label: param.paramname, value: param});
      } else if (!query && param && param.paramname) {
        filtered.push({label: param.paramname, value: param});
      } else if (query.length === 0) {
        filtered.push({label: param.paramname, value: param});
      }
    }
    return filtered;
  }
  filterCDParam(query, params: any[]): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < params.length; i++) {
      const param = params[i];
      const paramname = param.deviceparam.paramname;
      if (param && query && paramname && paramname.toLowerCase().indexOf((query + '').toLowerCase()) !== -1) {
        filtered.push({label: paramname, value: param});
      } else if (!query && param && paramname) {
        filtered.push({label: paramname, value: param});
      } else if (query.length === 0) {
        filtered.push({label: paramname, value: param});
      }
    }
    return filtered;
  }
  filterUnit(query, units: any[]): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < units.length; i++) {
      const unit = units[i];
      const paramname = unit.deviceconnect?.connectname;
      if (unit && query && paramname && paramname.toLowerCase().indexOf((query + '').toLowerCase()) !== -1) {
        filtered.push({label: paramname, value: unit});
      } else if (!query && unit && paramname) {
        filtered.push({label: paramname, value: unit});
      } else if (query.length === 0) {
        filtered.push({label: paramname, value: unit});
      }
    }
    return filtered;
  }
}
